import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@shared/auth';
import { PAGE_ROUTES } from '@shared/core-data';
import { ApprovalStatus } from '@shared/data-access';

export const createAccountGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const userService = inject(UserService);
  const currentUser = userService.currentUser();

  if (currentUser?.isAdmin) {
    router.navigate(['/']).then();
    return false;
  }

  if (
    currentUser?.organization &&
    currentUser?.organization?.approvalStatus !== ApprovalStatus.Rejected
  ) {
    router.navigate(['/' + PAGE_ROUTES.WAIT]).then();
    return false;
  }

  return true;
};
